import React from 'react'
import { Link } from 'react-router-dom'
import ImageCarousel from '../components/ImageCarousel'
import worldMap from '../assets/world_map.jpg'
import working1 from '../assets/working_1.jpg'
import working2 from '../assets/working_2.jpg'
import working3 from '../assets/working_3.jpg'

const Home = () => {
  const homeStyles = {
    container: {
      position: 'relative',
      width: '100%',
    },
    // Welcome Section
    welcomeSection: {
      padding: '80px 20px',
      backgroundColor: '#fff',
      maxWidth: '1200px',
      margin: '0 auto',
    },
    welcomeContent: {
      textAlign: 'center',
      maxWidth: '800px',
      margin: '0 auto',
    },
    sectionTitle: {
      fontSize: '2.5rem',
      fontWeight: '700',
      color: 'var(--color-primary)',
      marginBottom: '20px',
      fontFamily: 'Poppins, sans-serif',
    },
    sectionSubtitle: {
      fontSize: '1.2rem',
      color: '#666',
      lineHeight: '1.8',
      marginBottom: '30px',
    },
    // Services Section
    servicesSection: {
      padding: '80px 20px',
      backgroundColor: '#f8f9fa',
    },
    servicesContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
    },
    servicesGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '30px',
      marginTop: '50px',
    },
    serviceCard: {
      backgroundColor: '#fff',
      padding: '40px 30px',
      borderRadius: '10px',
      boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      cursor: 'pointer',
    },
    serviceCardHover: {
      transform: 'translateY(-5px)',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
    },
    serviceIcon: {
      fontSize: '3rem',
      marginBottom: '20px',
      color: 'var(--color-secondary)',
    },
    serviceTitle: {
      fontSize: '1.5rem',
      fontWeight: '600',
      color: 'var(--color-primary)',
      marginBottom: '15px',
    },
    serviceDescription: {
      fontSize: '1rem',
      color: '#666',
      lineHeight: '1.6',
    },
    // Why Choose Us Section
    whyChooseSection: {
      padding: '80px 20px',
      backgroundColor: '#fff',
    },
    whyChooseContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
    },
    whyChooseGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '40px',
      marginTop: '50px',
    },
    featureBox: {
      textAlign: 'center',
      padding: '30px 20px',
    },
    featureNumber: {
      fontSize: '3.5rem',
      fontWeight: '700',
      color: 'var(--color-secondary)',
      marginBottom: '15px',
    },
    featureTitle: {
      fontSize: '1.3rem',
      fontWeight: '600',
      color: 'var(--color-primary)',
      marginBottom: '10px',
    },
    featureDescription: {
      fontSize: '1rem',
      color: '#666',
      lineHeight: '1.6',
    },
    // Global Reach Section
    globalSection: {
      padding: '80px 20px',
      backgroundColor: 'var(--color-primary)',
      color: '#fff',
    },
    globalContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
      textAlign: 'center',
    },
    globalTitle: {
      fontSize: '2.5rem',
      fontWeight: '700',
      marginBottom: '20px',
      color: '#fff',
    },
    globalDescription: {
      fontSize: '1.2rem',
      lineHeight: '1.8',
      marginBottom: '50px',
      opacity: 0.9,
    },
    imagePlaceholder: {
      width: '100%',
      height: '400px',
      backgroundColor: '#e0e0e0',
      borderRadius: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '2px dashed #ccc',
      marginTop: '30px',
    },
    placeholderText: {
      fontSize: '1.1rem',
      color: '#999',
      textAlign: 'center',
      padding: '20px',
    },
    // Statistics Section
    statsSection: {
      padding: '80px 20px',
      backgroundColor: '#f8f9fa',
    },
    statsContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
    },
    statsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '40px',
      marginTop: '50px',
    },
    statBox: {
      textAlign: 'center',
      padding: '30px 20px',
    },
    statNumber: {
      fontSize: '3.5rem',
      fontWeight: '700',
      color: 'var(--color-secondary)',
      marginBottom: '10px',
    },
    statLabel: {
      fontSize: '1.1rem',
      color: 'var(--color-primary)',
      fontWeight: '600',
    },
    // CTA Section
    ctaSection: {
      padding: '80px 20px',
      backgroundColor: 'var(--color-secondary)',
      color: '#fff',
      textAlign: 'center',
    },
    ctaContainer: {
      maxWidth: '800px',
      margin: '0 auto',
    },
    ctaTitle: {
      fontSize: '2.5rem',
      fontWeight: '700',
      marginBottom: '20px',
      color: '#fff',
    },
    ctaDescription: {
      fontSize: '1.2rem',
      lineHeight: '1.8',
      marginBottom: '40px',
      opacity: 0.95,
    },
    ctaButton: {
      backgroundColor: '#fff',
      color: 'var(--color-secondary)',
      padding: '15px 40px',
      fontSize: '1.1rem',
      fontWeight: '600',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      textDecoration: 'none',
      display: 'inline-block',
    },
  };

  return (
    <div style={homeStyles.container}>
      {/* Hero Carousel Section */}
      <ImageCarousel />

      {/* Welcome Section */}
      <section style={homeStyles.welcomeSection} data-aos="fade-up">
        <div style={homeStyles.welcomeContent}>
          <h2 style={homeStyles.sectionTitle}>
            Leading Offshore Crew Manning Services Worldwide
          </h2>
          <p style={homeStyles.sectionSubtitle}>
            Bill Gates Offshore Crew Manning is a trusted partner in providing skilled and experienced 
            maritime professionals to offshore operations across the globe. With years of expertise in 
            crew management, we ensure the highest standards of safety, professionalism, and efficiency 
            for your offshore projects.
          </p>
        </div>
      </section>

      {/* Services Section - 2 Main Sections */}
      <section style={homeStyles.servicesSection} data-aos="fade-up">
        <div style={homeStyles.servicesContainer}>
          <h2 style={{...homeStyles.sectionTitle, textAlign: 'center'}}>Our Services</h2>
          <p style={{...homeStyles.sectionSubtitle, textAlign: 'center', marginBottom: '40px'}}>
            We serve companies seeking crew and maritime professionals seeking employment.
          </p>
          <div style={homeStyles.servicesGrid}>
            <div 
              style={homeStyles.serviceCard}
              data-aos="fade-up"
              data-aos-delay="100"
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, homeStyles.serviceCardHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.1)';
              }}
            >
              <div style={homeStyles.serviceIcon}>🏢</div>
              <h3 style={homeStyles.serviceTitle}>Crew for Companies & Industries</h3>
              <p style={homeStyles.serviceDescription}>
                We offer crew members to companies and industries for both ship and offshore operations. 
                Qualified deck officers, engineers, and support staff ready for your maritime needs.
              </p>
            </div>

            <div 
              style={homeStyles.serviceCard}
              data-aos="fade-up"
              data-aos-delay="200"
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, homeStyles.serviceCardHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.1)';
              }}
            >
              <div style={homeStyles.serviceIcon}>👤</div>
              <h3 style={homeStyles.serviceTitle}>For Job Seekers</h3>
              <p style={homeStyles.serviceDescription}>
                If you are a maritime professional looking for employment, we welcome you. 
                We connect qualified seafarers and offshore workers with companies and vessels worldwide.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section style={homeStyles.whyChooseSection} data-aos="fade-up">
        <div style={homeStyles.whyChooseContainer}>
          <h2 style={{...homeStyles.sectionTitle, textAlign: 'center'}}>Why Choose Us</h2>
          <div style={homeStyles.whyChooseGrid}>
            <div style={homeStyles.featureBox} data-aos="zoom-in" data-aos-delay="100">
              <div style={homeStyles.featureNumber}>15+</div>
              <h3 style={homeStyles.featureTitle}>Years of Experience</h3>
              <p style={homeStyles.featureDescription}>
                Extensive experience in offshore crew manning and maritime operations
              </p>
            </div>

            <div style={homeStyles.featureBox} data-aos="zoom-in" data-aos-delay="200">
              <div style={homeStyles.featureNumber}>5000+</div>
              <h3 style={homeStyles.featureTitle}>Qualified Crew</h3>
              <p style={homeStyles.featureDescription}>
                Large pool of certified and experienced maritime professionals
              </p>
            </div>

            <div style={homeStyles.featureBox} data-aos="zoom-in" data-aos-delay="300">
              <div style={homeStyles.featureNumber}>50+</div>
              <h3 style={homeStyles.featureTitle}>Countries Served</h3>
              <p style={homeStyles.featureDescription}>
                Global reach with operations spanning across continents
              </p>
            </div>

            <div style={homeStyles.featureBox} data-aos="zoom-in" data-aos-delay="400">
              <div style={homeStyles.featureNumber}>100%</div>
              <h3 style={homeStyles.featureTitle}>Compliance Rate</h3>
              <p style={homeStyles.featureDescription}>
                Full compliance with international maritime standards and regulations
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Global Reach Section */}
      <section style={homeStyles.globalSection} data-aos="fade-up">
        <div style={homeStyles.globalContainer}>
          <h2 style={homeStyles.globalTitle}>Our Global Reach</h2>
          <p style={homeStyles.globalDescription}>
            We provide offshore crew manning services to clients across the world, from the 
            North Sea to the Gulf of Mexico, from Southeast Asia to West Africa. Our extensive 
            network ensures we can deliver the right crew, at the right time, anywhere in the world.
          </p>
          <div 
            style={{
              ...homeStyles.imagePlaceholder,
              height: '600px',
              backgroundColor: 'transparent',
              border: 'none',
              overflow: 'hidden',
            }} 
            data-aos="zoom-in"
          >
            <img 
              src={worldMap} 
              alt="World map showing global operations and service locations" 
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '10px',
              }}
            />
          </div>
        </div>
      </section>

      {/* Statistics Section */}
      <section style={homeStyles.statsSection} data-aos="fade-up">
        <div style={homeStyles.statsContainer}>
          <h2 style={{...homeStyles.sectionTitle, textAlign: 'center'}}>Our Impact</h2>
          <div style={homeStyles.statsGrid}>
            <div style={homeStyles.statBox} data-aos="fade-up" data-aos-delay="100">
              <div style={homeStyles.statNumber}>200+</div>
              <div style={homeStyles.statLabel}>Active Vessels</div>
            </div>

            <div style={homeStyles.statBox} data-aos="fade-up" data-aos-delay="200">
              <div style={homeStyles.statNumber}>98%</div>
              <div style={homeStyles.statLabel}>Client Satisfaction</div>
            </div>

            <div style={homeStyles.statBox} data-aos="fade-up" data-aos-delay="300">
              <div style={homeStyles.statNumber}>24/7</div>
              <div style={homeStyles.statLabel}>Support Available</div>
            </div>

            <div style={homeStyles.statBox} data-aos="fade-up" data-aos-delay="400">
              <div style={homeStyles.statNumber}>1000+</div>
              <div style={homeStyles.statLabel}>Projects Completed</div>
            </div>
          </div>
        </div>
      </section>

      {/* Image Gallery Section */}
      <section style={{...homeStyles.servicesSection, padding: '80px 20px'}} data-aos="fade-up">
        <div style={homeStyles.servicesContainer}>
          <h2 style={{...homeStyles.sectionTitle, textAlign: 'center'}}>Our Operations</h2>
          <div style={homeStyles.servicesGrid}>
            <div
              style={{
                ...homeStyles.imagePlaceholder,
                backgroundColor: 'transparent',
                border: 'none',
                overflow: 'hidden',
              }}
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <img
                src={working1}
                alt="Offshore platform or vessel with crew members"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: '10px',
                }}
              />
            </div>

            <div
              style={{
                ...homeStyles.imagePlaceholder,
                backgroundColor: 'transparent',
                border: 'none',
                overflow: 'hidden',
              }}
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <img
                src={working2}
                alt="Crew members in training or safety drill"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: '10px',
                }}
              />
            </div>

            <div
              style={{
                ...homeStyles.imagePlaceholder,
                backgroundColor: 'transparent',
                border: 'none',
                overflow: 'hidden',
              }}
              data-aos="zoom-in"
              data-aos-delay="300"
            >
              <img
                src={working3}
                alt="Modern offshore vessel or rig"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: '10px',
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section style={homeStyles.ctaSection} data-aos="fade-up">
        <div style={homeStyles.ctaContainer}>
          <h2 style={homeStyles.ctaTitle}>Ready to Partner With Us?</h2>
          <p style={homeStyles.ctaDescription}>
            Let us help you find the right crew for your offshore operations. Contact us today 
            to discuss your requirements and discover how we can support your maritime projects.
          </p>
          <Link 
            to="/contact" 
            style={homeStyles.ctaButton}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 5px 20px rgba(0, 0, 0, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Get In Touch
          </Link>
        </div>
      </section>
    </div>
  )
}

export default Home